import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m11.156 1.022-2.643 6.9h5.011c.373 0 .639.256.639.593 0 .204-.08.382-.231.568l-.562.722a5.5 5.5 0 0 0-2.42.747l.987-1.31H6.465l2.424-5.306-5.005 6.646h5.48l-2.429 5.3 1.303-1.73q-.168.647-.168 1.343-.001.516.094 1.005l-2.293 2.95c-.577.754-1.552.257-1.198-.656l2.643-6.89h-5.01c-.373 0-.639-.258-.639-.604 0-.195.08-.372.23-.567L9.96.374c.576-.762 1.552-.266 1.197.648"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.295 15.495C18.295 17.96 16.23 20 13.79 20c-2.465 0-4.505-2.022-4.505-4.505 0-2.465 2.04-4.505 4.505-4.505 2.475 0 4.505 2.04 4.505 4.505m-5.01-2.616v2.217h-1.597a.56.56 0 0 0-.558.54c0 .302.248.55.558.55h2.147c.31 0 .55-.239.55-.55V12.88a.54.54 0 0 0-.55-.532c-.302 0-.55.23-.55.532"
    }, null, -1)
  ])))
}
export default { render: render }